import { Matrix } from "../../maths/Matrix";
const TEMPMAT4_ARRAY = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
export class RenderState2D {
    static restoreTempArray() {
        TEMPMAT4_ARRAY[0] = 1;
        TEMPMAT4_ARRAY[1] = 0;
        TEMPMAT4_ARRAY[4] = 0;
        TEMPMAT4_ARRAY[5] = 1;
        TEMPMAT4_ARRAY[12] = 0;
        TEMPMAT4_ARRAY[13] = 0;
    }
    static clear() {
        RenderState2D.worldAlpha = 1;
    }
}
RenderState2D.worldMatrix4 = TEMPMAT4_ARRAY;
RenderState2D.worldMatrix = new Matrix();
RenderState2D.matWVP = null;
RenderState2D.worldAlpha = 1.0;
RenderState2D.worldScissorTest = false;
RenderState2D.width = 0;
RenderState2D.height = 0;
RenderState2D.InvertY = false;
